var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showReserve
        ? _c("div", { staticClass: "reserveWrapper" }, [
            _c("h1", [_vm._v("Reserving the property")]),
            _vm._v(" "),
            _c("h2", [
              _vm._v(
                "\n      To ensure that this property is secured, the purchaser is entitled to\n      place a reservation on the property for a 7 day exclusive period, free\n      of competition, to seek advice and proceed with the sale.\n    "
              )
            ]),
            _vm._v(" "),
            _c("button", { staticClass: "btn", on: { click: _vm.reserve } }, [
              _vm._v("Reserve this property")
            ]),
            _vm._v(" "),
            _vm.showCall
              ? _c(
                  "button",
                  { staticClass: "btn", on: { click: _vm.openPop } },
                  [_vm._v("\n      Request a call\n    ")]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "line" }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.pop
          ? _c("div", { staticClass: "popWrp" }, [
              _c(
                "div",
                { staticClass: "out", class: { short: _vm.isConfirm } },
                [
                  _c(
                    "div",
                    { staticClass: "inn", class: "tenant-" + _vm.tenant },
                    [
                      !_vm.isConfirm
                        ? _c("h1", { class: "tenant-" + _vm.tenant }, [
                            _vm._v(
                              "\n            Confirm sending request?\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isConfirm
                        ? _c("h2", [
                            _vm._v(
                              "\n            Are you sure you want to send the request for a callback?\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isConfirm
                        ? _c("h1", [_vm._v("Request a call back sent!")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isConfirm
                        ? _c("h2", [
                            _vm._v(
                              "\n            Someone from the UNIFI team will be in touch with you in the next\n            24 hours!\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isConfirm
                        ? _c("div", { staticClass: "btns" }, [
                            _c("button", { on: { click: _vm.closePop } }, [
                              _vm._v("No thanks")
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "link",
                                attrs: { href: _vm.link, target: "_blank" },
                                on: { click: _vm.confirm }
                              },
                              [_vm._v("Yes please")]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isConfirm
                        ? _c(
                            "button",
                            {
                              staticClass: "close",
                              on: { click: _vm.closePop }
                            },
                            [_vm._v("\n            Okay\n          ")]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a3a1aeda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3a1aeda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/reserve.vue
// module id = null
// module chunks = 